<template>
<div class="course-detail">
    <div class="course-infos">
        <div class="info dj-container">
            <div class="dj-container">
                <Breadcrumb>
                    <router-link to="/console" style="color: #fff"><span>课程</span></router-link>
                    <span v-if="course.itemName"> / </span>
                    <router-link :to="{path:'/console', query:{itemIdParam:course.itemId}}">
                        <span style="color: #fff">{{course.itemName}}</span>
                    </router-link>
                    <span v-if="course.stageName"> / </span>
                    <router-link :to="{path:'/console', query:{itemIdParam:course.itemId, stageIdParam:course.stageId}}">
                        <span style="color: #fff">{{ course.stageName }}</span>
                    </router-link>
                </Breadcrumb>
                <h1 class="course-title">{{ course.courseName }}</h1>
            </div>
        </div>
    </div>
    <div class="dj-container">
        <Tabs :animated="false" class="dj-container" @on-click="handleTabClick">
            <TabPane name="ppt" label="课件" icon="md-laptop" v-if="course.courseWare && userType !== 'STUDENT'">
                <div style="height: 32px">

                    <img style="float: right; position: relative;cursor:pointer;width: 25px;height: 25px" src="https://wup-oss-1252338237.cos.ap-shanghai.myqcloud.com/api/20210315/00c4f805745049e88dd058517a6c6e35.png" @click="fullScreen('.pptx-c')" />
                </div>
                <div class="spin-container pptx-iframe" v-if="course.courseWare">
                    <div class="pptx-c" :style="{
                width: videos.length || outSites.length ? '80%' : '100%',
              }">
                        <Spin size="large" style="z-index: 100" fix v-if="loadingpptx"></Spin>
                        <!-- <div class="ppt-mask" v-if="!loadingpptx"></div> -->
                        <div class="ppt-mask-bottom" v-if="!loadingpptx"></div>
                        <!-- <iframe
                class="pptx-iframe dfs"
                style="float: left"
                @load="loadingpptx = false"
                :src="
                  'https://ow365.cn/?i=24126&ssl=1&furl=' + course.courseWare
                "
                frameborder="0"
              ></iframe> -->
                        <iframe seamless security="restricted" sandbox="allow-scripts allow-same-origin allow-popups" id="myPptIframe" class="pptx-iframe dfs" style="float: left;margin-top: -6px" @load="loadingpptx = false" :src="course.courseWare" frameborder="0"></iframe>
                        <!-- https://view.officeapps.live.com/op/view.aspx?src= -->
                    </div>
                    <div class="video-item" v-if="videos.length" style="margin-bottom: 20px">
                        <h4>视频</h4>
                        <div v-for="(v, i) in videos" :key="i" style="margin-top: 5px">
                            <video :src="v" controls controlslist="nodownload" :disablePictureInPicture="true"></video>
                            <span style="content: 'content';font-size: xx-small; ">{{getFileName(v)}}</span>
                        </div>
                    </div>
                    <div class="video-item wailian" v-if="outSites.length">
                        <hr />
                        <h4 class="vide0-title">外链</h4>
                        <div v-for="v in outSites" :key="v.value" class="site-item">
                            <h4>
                                <a href="#" target="_blank" @click="onClickOutSite(v.url)">{{
                    v.label
                  }}</a>
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="dj-container" style="padding: 30px 0 0">
                    <Form label-position="top">
                        <FormItem label="课程反馈：">
                            <p>课程有问题，或者您有更好的课程教授经验，欢迎给我们反馈，一经采纳更有精彩好礼等您来拿哦</p>
                            <wedit v-model="content" :height="50"></wedit>
                        </FormItem>
                        <FormItem label="反馈附件：">
                            <myFiles v-model="files"></myFiles>
                        </FormItem>
                        <FormItem>
                            <Button type="primary" @click="submit" :disabled="!content.trim()" :loading="loading">提交</Button>
                        </FormItem>
                    </Form>
                </div>
            </TabPane>
            <!--新版讲义(通过wps分享连接)-->
            <TabPane name="newHandout" label="课案" icon="md-book" v-if="course.newHandout && userType !== 'STUDENT'">
              <div class="spin-container">
                <div class="spin-container pptx-iframe" v-if="course.newHandout">
                    <div class="pptx-c" :style="{width: '100%',}">
                        <Spin size="large" style="z-index: 100" fix v-if="loadingnewhandout"></Spin>
                        <div class="ppt-mask-bottom" v-if="!loadingnewhandout"></div>
                        <iframe seamless security="restricted" sandbox="allow-scripts allow-same-origin allow-popups" id="myPptIframe" class="pptx-iframe dfs" style="float: left;margin-top: -6px" @load="loadingnewhandout = false" :src="course.newHandout" frameborder="0"></iframe>
                    </div>
                </div>
              </div>
            </TabPane>
            <TabPane name="pdf" label="讲义" icon="md-book" v-if="userType !== 'STUDENT' && course.handout">
                <div class="spin-container">
                    <TXPDF v-if="course.handout" ref="pdf" :src="course.handout" :style="{
                width: videos.length || outSites.length ? '80%' : '100%',
                float: 'left',
              }" />
                    <div class="video-item" v-if="videos.length" style="margin-bottom: 20px">
                        <h4>视频</h4>
                        <video v-for="(v, i) in videos" :key="i" :src="v" controls controlslist="nodownload" :disablePictureInPicture="true"></video>
                    </div>
                    <div class="video-item wailian" v-if="outSites.length">
                        <h4 class="vide0-title">外链</h4>
                        <div v-for="v in outSites" :key="v.value" class="site-item">
                            <h3>
                                <a href="#" target="_blank" @click="onClickOutSite(v.url)">{{
                    v.label
                  }}</a>
                            </h3>
                        </div>
                    </div>
                </div>
            </TabPane>
            <TabPane v-if="course.techVideo && userType !== 'STUDENT'" name="techVideo" label="说课视频" icon="logo-youtube">
                <div class="spin-container" :style="{
                width: techVideos.length  ? '80%' : '100%',
                float: 'left',
              }">
                    <Spin size="large" fix v-if="loadingtechVideo"></Spin>
                    <video width="100%" @canplay="loadingtechVideo = false" controls :src="course.techVideo" controlslist="nodownload" :disablePictureInPicture="true"></video>
                    <span style="content: 'content';">{{getFileName(course.techVideo)}}</span>
                </div>
                <div class="video-list" v-if="techVideos.length" style="margin-bottom: 20px">
                    <h4>列表</h4>
                    <div v-for="(v, i) in techVideos" :key="i" style="margin-top: 5px">
                        <video :src="v" controls controlslist="nodownload" :disablePictureInPicture="true"></video>
                        <span style="content: 'content';font-size: xx-small; ">{{getFileName(v)}}</span>
                    </div>
                </div>
            </TabPane>
            <!--
        <TabPane
          v-if="course.recordVideo && userType !== 'STUDENT'"
          name="recordVideo"
          label="实录视频"
          icon="logo-youtube"
        >
          <div class="spin-container"
               :style="{
                width: recordVideos.length  ? '80%' : '100%',
                float: 'left',
              }">
            <Spin size="large" fix v-if="loadingrecordVideo"></Spin>
            <video
              width="100%"
              @canplay="loadingrecordVideo = false"
              controls
              :src="course.recordVideo"
              controlslist="nodownload"
              :disablePictureInPicture="true"
            ></video>
            <span style="content: 'content';">{{getFileName(course.recordVideo)}}</span>
          </div>
          <div
                  class="video-list"
                  v-if="recordVideos.length"
                  style="margin-bottom: 20px"
          >
              <h4>列表</h4>
              <div  v-for="(v, i) in recordVideos"  :key="i" style="margin-top: 5px">
                  <video
                          :src="v"
                          controls
                          controlslist="nodownload"
                          :disablePictureInPicture="true"
                  ></video>
                  <span style="content: 'content';font-size: xx-small; " >{{getFileName(v)}}</span>
              </div>
          </div>
        </TabPane>
        -->
            <TabPane v-if="course.makeVideo" name="makeVideo" label="制作视频" icon="logo-youtube">
                <div class="spin-container" :style="{
                width: makeVideos.length  ? '80%' : '100%',
                float: 'left',
              }">
                    <Spin size="large" fix v-if="loadingmakeVideo"></Spin>
                    <video width="100%" @canplay="loadingmakeVideo = false" controls :src="course.makeVideo" controlslist="nodownload" :disablePictureInPicture="true"></video>
                    <!-- <span style="content: 'content';">{{getFileName(course.makeVideo)}}</span> -->
                </div>
                <div class="video-list" v-if="makeVideos.length" style="margin-bottom: 20px">
                    <h4>列表</h4>
                    <div v-for="(v, i) in makeVideos" :key="i" style="margin-top: 5px">
                        <video :src="v" controls controlslist="nodownload" :disablePictureInPicture="true"></video>
                        <!-- <span style="content: 'content';font-size: xx-small; " >{{getFileName(v)}}</span> -->
                    </div>
                </div>
            </TabPane>
            <TabPane name="materialExpand" label="资料拓展" icon="md-book" v-if="course.materialExpand">
                <div class="spin-container">
                    <div class="material-expand" v-html="course.materialExpand"></div>
                </div>
            </TabPane>
            <TabPane name="pdfs" label="项目手册" icon="md-book" v-if="course.projectManual">
                <div class="spin-container">
                    <TXPDF v-if="course.projectManual" ref="pdfs" :src="course.projectManual" :style="{
                width: videos.length || outSites.length ? '80%' : '100%',
                float: 'left',
              }" />
                    <div class="dj-container" style="padding: 30px 0 0" v-if="userType === 'STUDENT'">
                        <Form label-position="top">
                            <FormItem label="课程反馈：">
                                <wedit v-model="content" :height="50"></wedit>
                            </FormItem>
                            <FormItem label="反馈附件：">
                                <myFiles v-model="files"></myFiles>
                            </FormItem>
                            <FormItem>
                                <Button type="primary" @click="submit" :disabled="!content.trim()" :loading="loading">提交</Button>
                            </FormItem>
                        </Form>
                    </div>
                </div>
            </TabPane>
            <TabPane v-if="materials.length" name="material" label="资料下载" icon="md-link">
                <Table border :columns="materialColumns" :data="materials">
                    <template slot-scope="{ row }" slot="file">
                        <div style="margin-right: 5px;border-radius: 1em;
                          background-color: #FAB95B;
                          border-color: #FAB95B;
                          width: 40px;
                          ">
                            <a v-if="row.file" :href="row.file" type="primary" style="color: white;
                    margin-left: 8px;
                    font-size: xx-small" target="_blank">下载</a>
                        </div>
                    </template>
                </Table>
            </TabPane>
        </Tabs>
    </div>
</div>
</template>

<script>
// import html2canvas from 'html2canvas';
// import "@/utils/SIMYOU-normal.js";
// import PDF from "@/components/PDF.vue";
//import PDF from "@/components/my-pdf";
import TXPDF from "@/components/tx-pdf";
import {
    fullScreen
} from "@/utils";
import {
    courseDecrypt
} from "../../utils";
import wedit from "@/components/wedit/index";
import {
    mapState
} from "vuex";
import myFiles from "./components/files";
export default {
    components: {
        TXPDF,
        wedit,
        myFiles
    },
    data() {
        return {
            content: "",
            files: "",
            loading: false,
            loadingpptx: true,
            loadingnewhandout: false,
            loadingpdf: false,
            loadingpdfs: false,
            loadingtechVideo: true,
            loadingrecordVideo: true,
            loadingmakeVideo: true,
            course: {},
            materials: [],
            videos: [],
            techVideos: [],
            recordVideos: [],
            makeVideos: [],
            outSites: [],
            materialColumns: [{
                    title: "名称",
                    key: "name",
                },
                /* {
                   title: "单位",
                   key: "numUnit",
                 },*/
                {
                    title: "文件",
                    key: "file",
                    slot: "file",
                },
            ],
        };
    },
    created() {
        const {
            id
        } = this.$route.query;
        if (id) {
            this.getCourseDetailById(id);
        }
        this.prohibit();
    },
    mounted() {},
    computed: {
        ...mapState({
            userType: (state) => state.userInfo.userType,
        }),
    },
    methods: {
        submit() {
            this.loading = true;
            this._r
                .post("course/comment/save", {
                    content: this.content,
                    files: this.files,
                    courseId: this.$route.query.id,
                })
                .then(() => {
                    this.$Message.success("反馈成功！");
                    this.content = "";
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleTabClick() {
            // 切换标签暂停视频播放
            let myVideos = document.getElementsByTagName('video');
            for (let i = 0; i < myVideos.length; i++) {
                let theVideo = myVideos[i];
                theVideo.pause();
            }
        },
        prohibit() { // 禁用鼠标右击、F12/Ctrl+Shift+I/Shift+F10/Ctrl+U
            if (process.env.NODE_ENV === 'development') {
                return;
            }
            document.onselectstart = function () {
                return false;
            }
            document.oncontextmenu = function () {
                return false;
            }
            document.onkeydown = function (e) {
                if (e.keyCode == 18 || e.keyCode == 123) {
                    return false
                }
            }
            document.onkeydown = function (e) {
                if ((e.ctrlKey) && (e.shiftKey) && (e.keyCode == 73)) {  //Ctrl+Shift+I
                    return false
                }
            }
            document.onkeydown = function (e) {
                if ((e.shiftKey) && (e.keyCode == 121)) {  //Shift+F10
                    return false
                }
            }
            document.onkeydown = function (e) {
                if ((e.ctrlKey) && (e.shiftKey) && (e.keyCode == 73)) {  //Ctrl+U
                    return false
                }
            }
        },
        getFileName(imageUrl) {
            //获取最后一个/的位置
            let site = imageUrl.lastIndexOf("/");
            //截取最后一个/后的值
            let name = imageUrl.substring(site + 1, imageUrl.length);
            return name.substring(0, name.lastIndexOf("."));
        },
        getCourseDetailById(id) {
            this._r
                .get("course/course/info/" + id)
                .then((res) => {
                    //加密
                    let aesCourse = courseDecrypt(res.course);
                    this.course = aesCourse;
                    res.course = aesCourse;
                    if (res.course.pptVideo) {
                        this.videos = res.course.pptVideo.split(";").reverse();
                    }
                    if (res.course.techVideo) {
                        this.dealTechVideos(res.course.techVideo)
                    }
                    if (res.course.recordVideo) {
                        this.dealRecordVideos(res.course.recordVideo)
                    }
                    if (res.course.makeVideo) {
                        this.dealMakeVideos(res.course.makeVideo)
                    }
                    if (res.course.outSite) {
                        const arr = res.course.outSite.split(";");
                        arr.forEach((v, i) => {
                            const [label, url] = v.split("=");
                            this.outSites.push({
                                label,
                                url,
                                value: i,
                            });
                        });
                    }
                    this.getMaterialById(id);
                })
                .then(() => {
                    this.full = new fullScreen();
                });
        },
        fullScreen(el) {
            this.full.Fullscreen(el);
        },
        dealTechVideos(techVideoData) {
            let techVideoArray = techVideoData.split(";").reverse();
            if (techVideoArray.length > 1) {
                this.course.techVideo = techVideoArray[0];
                this.techVideos = techVideoArray.slice(1, techVideoArray.length);
            } else {
                this.course.techVideo = techVideoData;
            }
        },
        dealRecordVideos(videoData) {
            let videoArray = videoData.split(";").reverse();
            if (videoArray.length > 1) {
                this.course.recordVideo = videoArray[0];
                this.recordVideos = videoArray.slice(1, videoArray.length);
            } else {
                this.course.recordVideo = videoData;
            }
        },
        dealMakeVideos(videoData) {
            let videoArray = videoData.split(";").reverse();
            if (videoArray.length > 1) {
                this.course.makeVideo = videoArray[0];
                this.makeVideos = videoArray.slice(1, videoArray.length);
            } else {
                this.course.makeVideo = videoData;
            }
        },
        getMaterialById(id) {
            this._r
                .get("course/material/list", {
                    params: {
                        courseId: id,
                        limit: -1,
                    },
                })
                .then((res) => {
                    this.materials = res.page.list;
                });
        },
        onClickOutSite(url) {
            if (!url) {
                return;
            }
            const arr = ["http://", "https://"];
            if (!arr.some((v) => url.includes(v))) {
                url = "http://" + url;
            }
            window.open(url, "_blank");
        },
    },
};
</script>

<style lang="scss">
.course-detail {
    .course-infos {
        height: 12.5rem;
        position: relative;
        /*background: url(https://edu2c-1252338237.cos.ap-shenzhen-fsi.myqcloud.com/common/593e7d0f0001e26206000338_4167886.jpg)*/
        /* background: url(https://edu2c-1252338237.cos.ap-shenzhen-fsi.myqcloud.com/common/course-title-bg_4163863.jpg) */
        /* center center; */
        background-size: cover;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            background-color: rgba($color: #000000, $alpha:0.2);
        }

        .info {
            position: relative;
            z-index: 2;
            color: #ffffff;

            .ivu-breadcrumb,
            .ivu-breadcrumb-item-separator,
            .ivu-breadcrumb>span:last-child {
                color: rgba(255, 255, 255, 0.5);
            }
        }

        .ivu-breadcrumb {
            padding: 2rem 0;
        }
    }

    .spin-container {
        position: relative;
        overflow: hidden;
    }

    .ivu-tabs-bar {
        margin-bottom: 0;
    }

    .toolbar-container {
        height: 32px;
        background-color: rgba(249, 249, 250, 1);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .toolbar-item {
            cursor: pointer;
        }
    }

    .printWrapper {
        margin: 0 auto;
    }

    .video-item {
        text-align: center;
        width: 19%;
        float: right;
        max-height: 380px;
        overflow: auto;

        video {
            width: 100%;
            height: auto;
        }
    }

    .video-list {
        text-align: center;
        width: 19%;
        float: right;
        max-height: 650px;
        overflow: auto;

        video {
            width: 100%;
            height: auto;
        }
    }
}

.vide0-title {
    text-align: center;
}

.site-item {
    margin: 5px 0;
    padding: 5px 0;
    // border: 1px solid #d6d3d3;
}

.introduction {
    background-color: #fff;
    padding: 22px;
}

.pptx-c {
    height: 700px;
    position: relative;
    overflow: hidden;
    float: left;
}

.dfs {
    height: calc(100% + 90px);
    width: 100%;
    transform: translateY(-90px);
}

.ppt-mask {
    height: 88px;
    width: 100%;
    background-color: #393a3d;
    position: absolute;
    z-index: 1;
}

.ppt-mask-bottom {
    height: 100px;
    width: 40px;
    // background-color: #fff;
    position: absolute;
    bottom: 60px;
    right: 19px;
    z-index: 10000;
}

.material-expand {
    padding: 20px;
    background-color: #fff;
}

// .wailian {
//   position: absolute;
//   right:-100px;
//   z-index: 10000;
// }
</style>
